import { Injectable } from '@angular/core';
import { TableFieldModel } from '@module-definition/table-field/common';
import { of } from 'rxjs';

@Injectable()
export class DemoFieldDefinitionService {
  getTableFields(entityInstanceId: number, tableFieldId: number) {
    return of(demoFields);
  }
}

const demoFields: TableFieldModel[] = [
  {
    width: 1,
    position: 1,
    id: 3121,
    name: 'rxttabl',
    label: 'rxttabl',
    hasMultipleValues: false,
    type: 1,
    displayType: 1,
    restrictions: [
      {
        mimeTypes: [],
        mimeTypesDataSource: [],
        key: 8,
        restrictionValue: 0,
      },
    ],
    formattings: [],
    entityIds: [],
    screenIds: [],
    inUse: false,
    parentChildLinkId: 1357,
    canDelete: true,
    canRemove: true,
    fieldOrigin: 1,
    isFilter: false,
    useOnReport: false,
    canHaveAggregate: false,
    isContractSystemField: false,
    isSystemField: false,
    currentDateTime: false,
    maximumAllowedCharacters: 0,
    isRequired: false,
  },
  {
    width: 1,
    position: 2,
    id: 3122,
    name: 'nrtab',
    label: 'nrtab',
    hasMultipleValues: false,
    type: 2,
    displayType: 1,
    restrictions: [
      {
        mimeTypes: [],
        mimeTypesDataSource: [],
        key: 7,
        restrictionValue: 0,
      },
      {
        mimeTypes: [],
        mimeTypesDataSource: [],
        key: 4,
        value: 1,
      },
    ],
    formattings: [
      {
        key: 1,
        value: 1,
      },
      {
        formattingValue: 2,
        key: 2,
        value: 0,
      },
    ],
    expression: '',
    entityIds: [],
    screenIds: [],
    inUse: false,
    parentChildLinkId: 1358,
    canDelete: true,
    canRemove: true,
    fieldOrigin: 1,
    isFilter: false,
    useOnReport: false,
    canHaveAggregate: true,
    isContractSystemField: false,
    isSystemField: false,
    currentDateTime: false,
    maximumAllowedCharacters: 0,
    isRequired: false,
  },
];
